import { ConflictStore } from "sh-conflict-store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('DELETE_SHIFTID_CONFLICT_STORE', function deleteShiftIdConflictStore(shiftId: string) {
   if (ConflictStore().shiftIdToConflictsMap.has(shiftId)) {
      ConflictStore().shiftIdToConflictsMap.delete(shiftId);
   }
});
